/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'motion/react';
import { useCurrentBreakpointName } from 'react-socks';

const InfoBanner = (props) => {
    let bannerClass = 'info-banner ' + props.type,
        currentBreakpoint = useCurrentBreakpointName(),
        bannerContent = null;
        
    const removeBanner = (e) => {

        if (typeof(Storage) !== undefined) {
			sessionStorage.setItem('bannerVisible', false);
		}

        props.closeCallback(e);

    }

    if (currentBreakpoint === 'desktop') {
        bannerContent = (
            <motion.div 
                className={bannerClass} 
                data-pw="banner"
                initial={{
                    height: 0
                }}
                animate={{
                    height: "35px"
                }}
                exit={{
                    height: 0
                }}
                transition={{
                    duration: 0.4,
                    ease: "easeOut"
                }}>
                <div className="info-banner-close" onClick={removeBanner} role="button" aria-label="close banner">
                    <i className="icon ion-close-round"></i>
                </div>
                <div className="info-banner-content">
                    {props.content}
                </div>
            </motion.div>
        )
    } else {
        bannerContent = (
            <div className={`${bannerClass} mobile`} data-pw="banner">
                <div className="info-banner-close" onClick={removeBanner} role="button" aria-label="close banner">
                    <i className="icon ion-close-round"></i>
                </div>
                <div className="info-banner-content">
                    {props.content}
                </div>
            </div>
        )
    }

    return bannerContent;
}

InfoBanner.displayName = "InfoBanner";

export default InfoBanner;
